// ZeusEmblem — the ornate Zeus crest for the GOD / Mesa de Deus identity.
//
// Vectorized from Pedro's PNG with potrace (1024px line-art → ~45KB SVG),
// optimized with svgo (precision 0) and given a gold→amber gradient. Rendered
// via `?url` + <img> (self-contained gradient resolves inside the file; works
// regardless of any svgr plugin). The divine yellow/blue glow is a CSS filter,
// applied by the caller.
import zeusEmblemUrl from './zeus-emblem.svg?url';

export default function ZeusEmblem({ size = 24, className = '', style, alt = '' }) {
  return (
    <img
      src={zeusEmblemUrl}
      width={size}
      height={size}
      alt={alt}
      aria-hidden={alt ? undefined : 'true'}
      draggable={false}
      className={className}
      style={style}
    />
  );
}
